import React from 'react'
import { useLoginModal } from '../../context/loginModalContext'
import { Result } from 'antd'
import { useTranslation } from 'react-i18next'

const LoginError = () => {
  const { setLoginModalVisible } = useLoginModal()
  const { t } = useTranslation()

  setLoginModalVisible('refresh')

  return (
    <div>
      <Result status="403" title={t('common.sessionEnded')} subTitle={t('common.loginAgain')} />
    </div>
  )
}

export default LoginError
